import React from "react";

import Checkbox from "@mui/material/Checkbox";

import FormControlLabel from "@mui/material/FormControlLabel";
import { BooleanField } from "../FieldService";
import {
	InformationRight,
	ReportFieldRights
} from "core/blueprint/trajectory/TrajectoryBlueprintService";

export type BooleanInputProps = {
	field: BooleanField;
	rights: ReportFieldRights;
	editable: boolean;
	onChange: (uuid: string, value: string) => void;
};

const BooleanInput: React.FC<BooleanInputProps> = (
	props: BooleanInputProps
) => {
	function toId(uuid: string): string {
		const separatorIndex = uuid.indexOf("#");
		return separatorIndex === -1 ? uuid : uuid.substring(0, separatorIndex);
	}

	return (
		<FormControlLabel
			control={
				<Checkbox
					checked={props.field.value}
					onChange={event =>
						props.onChange(
							props.field.uuid,
							event.target.checked.toString()
						)
					}
				/>
			}
			disabled={
				!props.editable ||
				props.rights[toId(props.field.uuid)][InformationRight.WRITE] ===
					false
			}
			label={props.field.name}
		/>
	);
};

export default BooleanInput;
